import './ui/all-ui';
import { Game } from "./game/game";
// Kick this off as early as possible.
Game.preload();
